import { Fragment } from 'react'
import { useSelector } from 'react-redux'
import { Area, Line, XAxis } from 'recharts'
import { ChartContainer } from '../../../../../common/chart/chartContainer'
import { Legend } from '../../../../../common/chart/legend'
import { formatByTheme } from '../../../../../helpers/theme'
import { CHART_COLOR } from '../../../constants'
import { getChartKey } from '../../../store/helper'
import { selectActiveRow, selectChartData } from '../../../store/slice'
import CustomLegend from './CustomLegend'
import { CustomTooltip } from './CustomTooltip'
import { getListTooltip, handleChartDataByUnit } from './helper'

const LineChart = ({ typePrefix, formatCurrency, val }) => {
  const activeRow = useSelector(selectActiveRow(typePrefix))
  const { chartData, titleById } = useSelector(selectChartData(typePrefix))
  const locale = useSelector((state) => state.i18n.locale)

  const chartKeys = Object.keys(titleById)
  const chartDataByUnit = handleChartDataByUnit(
    chartData,
    val.unit,
    formatCurrency.convertValue,
  )

  const customTooltip = ({ data }) => {
    return (
      <CustomTooltip
        label={data.year}
        list={getListTooltip(titleById, data, activeRow)}
        locale={locale}
      />
    )
  }

  return (
    <div className="dFlex" style={{ gap: 36 }}>
      <ChartContainer
        data={chartDataByUnit}
        width={900}
        height={340}
        yAxis={[
          {
            yAxisId: 'comboChart',
            dataKeys: chartKeys
              .map((key) => [
                getChartKey(key, activeRow, 'areaKey'),
                getChartKey(key, activeRow, 'lineKey'),
              ])
              .flat(),
            isLineArea: true,
            unit: val.unit === '%' ? '%' : '',
          },
        ]}
        tooltip={{
          schema: {
            renderCustomContent: customTooltip,
          },
        }}
      >
        <XAxis
          height={20}
          padding={{ left: 74, right: 74 }}
          dataKey="year"
          textAnchor="middle"
          tickLine={false}
          tickMargin={9}
          axisLine={{ stroke: formatByTheme('#9C9C9C') }}
          stroke="#9C9C9C"
          interval={0}
        />
        {chartKeys.map((key) => {
          return (
            <Fragment key={key}>
              <Line
                yAxisId="comboChart"
                dataKey={getChartKey(key, activeRow, 'lineKey')}
                stroke={CHART_COLOR[key]?.stroke ?? '#006AA6'}
                strokeWidth={2}
                dot={false}
                activeDot={{ r: 6 }}
              />
              <Area
                yAxisId="comboChart"
                dataKey={getChartKey(key, activeRow, 'areaKey')}
                stroke="none"
                fill={CHART_COLOR[key]?.fill ?? 'rgba(113, 126, 205, 0.15)'}
                activeDot={false}
              />
            </Fragment>
          )
        })}
      </ChartContainer>
      <Legend
        className={'flexColumn'}
        items={chartKeys.map((key) => {
          return {
            title: titleById[key],
            color: CHART_COLOR[key]?.stroke ?? '#006AA6',
            iconCustom: true,
            renderCustomIcon: () => (
              <CustomLegend
                backgroundColor={CHART_COLOR[key]?.stroke ?? '#006AA6'}
              />
            ),
          }
        })}
      />
    </div>
  )
}

export default LineChart
